import { React, } from 'react'
import { Row, Col, Grid, Card, ConfigProvider, Result } from 'antd';
import NavBar from './NavBar';
import whatsappico from '../img/whatsapp-icon.png';
import llamadaico from '../img/llamadaicon.png';
import { Footer } from './Footer';
import { ORIGEN_ID, ORIGEN_CONFIG } from '../utils/origenes.config';
import { useEffect } from 'react';


/**
 * Componente para mostrar un error en el pago y/o servicio
 * @param {} Error 
 * @returns vista con diseño de error
 */
function Error({ tipo = "EXPIRADA", mensaje }) {
  const cardPrincipalStyle = {
    width: '100%',
    boxShadow: '1px 10px 10px 1px rgba(90, 116, 148, 0.3)',
    borderRadius: '0px',
    marginBottom: '30px',
    zIndex: ''
  };

  const cardBodyStyle = {
    width: '100%',
    borderRadius: '0px',
    height: '100%',
  };

  const divresponsive = {
    position: 'relative',
    display: 'grid',
    placeItems: 'center',
    aling: 'center',
    top: '0',
    bottom: '0',
    minHeight: '150px',
    height: '100vh'
  };

  const containerStyle = {
    position: 'absolute',
    maxwidth: '1200px',
    maxHeight: '1456px',
    alingcontent: 'center'
  };

  const rowFooterStyle = {
    bottom: '0px',
    position: 'absolute',
    width: '100%',
    marginTop: '0px'
  };

  const footerStyle = {
    textAlign: 'center',
    color: 'gray',
    position: 'absolute',
    width: '100%',
    marginTop: '30px',
    paddingLeft: '0px',
    paddingRight: '0px',
  };

  const stylesNavBar = {
    navBarHeigth: '70px',
    iconsNavbarWidth: '165px',
    iconsNavbarHeigth: '200px',
    stepsWidth: '25px',
    stepsHeigth: '25px',
    stepsSize: '',
  };

  const divStyle = {
    background: 'linear-gradient(270deg, #1a3992 0%, #e6002b 100%)',
    height: '2px',
    transform: 'matrix(-1, 0, 0, 1, 0, 0)'
  }

  const sucursal = {
    data: [{
      id: 1,
      error: 1
    }]
  };

  let titulo = "¡Este link ha expirado!";
  let subtitulo = "Para poder realizar tu pago solicita un nuevo acceso con un ejecutivo de nuestro Centro de Atención.";

  if (tipo === "RECHAZADA_APYMSA") {
    titulo = "¡Pago rechazado!";
    subtitulo = 'Estamos experimentando problemas con este método de pago, lamentamos las molestias que esto le ocasiona. ' +
      'Inténtalo de nuevo más tarde o cambia el método de pago.';
  }

  if (tipo === "DEFAULT") {
    titulo = "¡Ocurrió un error!";
    subtitulo = "No fue posible completar la operación. Para poder realizar tu pago solicita un nuevo acceso con un ejecutivo de nuestro Centro de Atención.";
  }
  if (mensaje) {
    subtitulo = mensaje;
  }
  

  useEffect(() => {
    if (tipo !== "RECHAZADA_APYMSA") return;
    const backUrl = ORIGEN_CONFIG[ORIGEN_ID.APYMSA]?.backUrl+"/?pago=rechazado";
    if (!backUrl) return;
    const timer = setTimeout(() => {
      sessionStorage.removeItem("openpayErrorMessage");
      window.location.href = backUrl;
    }, 8000);
    return () => clearTimeout(timer);

  }, [tipo]);

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  async function responsiveSize(screens) {
    let screennow;
    {
      Object.entries(screens)
        .filter((screen) => !!screen[1])
        .map((screen) => (
          screennow = screen[0]
        ))
    }

    switch (screennow) {
      case "xxl":
        containerStyle.top = '2%';
        stylesNavBar.navBarHeigth = '65px';
        stylesNavBar.iconsNavbarWidth = '165px';
        stylesNavBar.iconsNavbarHeigth = '200px';
        stylesNavBar.stepsSize = 'large';
        stylesNavBar.paddingImg = '0px';
        cardPrincipalStyle.width = '98%';
        divresponsive.minHeight = '360px';
        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0px';

        break;
      case "xl":
        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0px';


        break;
      case "lg":
        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0px';


        break;
      case "md":
        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0px';



        break;
      case "sm":
        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0px';


        break;
      case "xs":
        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0px';

        break;

      default:
        break;
    }
  }

  responsiveSize(screens);

  return (
    <div className="Error">
      <NavBar stylesNavBar={stylesNavBar} sucursal={sucursal} />
      <div style={divStyle}></div>
      <div style={divresponsive}>
        <div className="container" style={containerStyle}>
          <Card style={cardPrincipalStyle} bodyStyle={cardBodyStyle} >
            <div>
              <ConfigProvider
                theme={{
                  token: {
                    colorSuccess: '#ff4d4f',
                    subtitleFontSize: 16
                  },
                  components: {
                    Result: {
                      extraMargin: '0px 0 0 0',
                      subtitleFontSize: 20,
                      colorTextHeading: '#ff4d4f',
                      colorTextDescription: '#3D3D3D'
                    }
                  }
                }}
              >
                <Result
                  status="error"
                  title={titulo}
                  subTitle={subtitulo}
                />
                {tipo === "RECHAZADA_APYMSA" && (
                  <Row style={{ margin: 4 }}>
                    <Col span={24} style={{ textAlign: 'center', color: '#3D3D3D' }}>
                      <strong>
                        Para cualquier duda o seguimiento, contacta a un ejecutivo <br />
                        de nuestro centro de atención.
                      </strong>
                    </Col>
                  </Row>
                )}
              </ConfigProvider>
            </div>
            <Row style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '20px' }}>
              {/* Teléfono */}
              <Col>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img style={{ marginRight: 8 }} src={llamadaico} width={32} height={32} alt="Llamada" />
                  <p style={{ margin: 0, color: 'black' }}>TELEFONO: 3332084420</p>
                </div>
              </Col>

              {/* WhatsApp 1 */}
              <Col>
                <a href="https://wa.me/523316026164?text=¡Necesito ayuda con mi pago!" style={{ textDecoration: 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={whatsappico} width={30} height={30} alt="WhatsApp" />
                    <p style={{ margin: 0, marginRight: 8, color: 'black' }}>APYMSA: 3316026164</p>
                  </div>
                </a>
              </Col>
              {/* WhatsApp 2 */}
              <Col>
                <a href="https://wa.me/3316025603?text=¡Necesito ayuda con mi pago!" style={{ textDecoration: 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={whatsappico} width={30} height={30} alt="WhatsApp" />
                    <p style={{ margin: 0, marginRight: 8, color: 'black' }}>AUTEX: 3316025603</p>
                  </div>
                </a>
              </Col>
            </Row>
          </Card>
        </div>

        <div style={rowFooterStyle}>
          <Row >
            <Col xs={{ span: 24, order: 5 }} sm={{ span: 24, order: 5 }} md={{ span: 24, order: 5 }} lg={{ span: 24, order: 5 }} xl={{ span: 24, order: 5 }} xxl={{ span: 24, order: 5 }}>
              <Footer footerStyle={footerStyle}></Footer>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Error;